import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { IUserInfo } from '~src/ts/models/IUserInfo';

export interface DetailDialogUserLinkProps {
  readonly user: IUserInfo;
  readonly urls: SpacesSiteUrls;
}

export function DetailDialogUserDetail(props: DetailDialogUserLinkProps): JSX.Element {
  return (props.user.isHiddenInternalUser ?
    <span data-tb-test-id="hidden-user-display" style={{color: CommonStyles.Colors.Grey178}}>
      {props.user.displayName}
    </span> :
    <TextLinkWidget
      testId="owner-user"
      href={props.urls.userUrl(props.user.username, props.user.domainName)}
      children={props.user.displayName}
    />
  );
}